import { IPageData, IPageParams } from "../types"

/**
 * $t('enum.E_FirewareUpgradeStatus.Success')
 * $t('enum.E_FirewareUpgradeStatus.Failed')
 * $t('enum.E_FirewareUpgradeStatus.Upgrading')
 * $t('enum.E_FirewareUpgradeStatus.Waiting')
 */
export enum E_FirewareUpgradeStatus {
    /**
     * 
     * 成功     
     */
    Success = 1,
    /**
     * 失败
     */
    Failed = 2,
    /**
     * 升级中
     */
    Upgrading = 3,
    /**
     * 等待升级
     */
    Waiting = 4,
}

/**
 * $t('enum.E_UpgradeStatus.Open')
 * $t('enum.E_UpgradeStatus.Close')
 */
export enum E_UpgradeStatus {
    /**
     * 开启
     */
    Open = 1,
    /**
     * 关闭
     */
    Close = 2,
}

/**
 * 设备类型
 * $t('enum.E_FirmwireDeviceType.Sensor')
 * $t('enum.E_FirmwireDeviceType.Gateway')
 */
export enum E_FirmwireDeviceType {
    /**
     * 传感器
     */
    Sensor = 1,
    /**
     * 网关
     */
    Gateway = 2,
}

/***
 * 产品类型
 */
export enum E_FirewireProductType {
    //#region 网关
    NGWP02 = 'NGWP02',
    //#endregion

    //#region 传感器
    VB24H = 'VB24H',
    //#endregion
}

/**
 * 固件类型
 */
export enum E_FirmwareType {
    MCU = 'MCU',
    BLE = 'BLE',
}

export interface IFirmwareUpgradItem {
    /**
     * 大小
     */
    fileSize: number
    /**
     * 文件描述
     */
    firmwareDesc: string
    /**
     * 固件名称
     */
    firmwareName: string
    /**
     * 固件类型
     */
    firmwareType: string
    /**
     * 固件版本
     */
    hardwareVersion: string
    /**
     * 软件版本
     */
    softwareVersion: string
    /**
     * 设备类型
     */
    deviceType: E_FirmwireDeviceType
    /**
     * 产品类型
     */
    productType: E_FirewireProductType
}

export interface IFirmwareUpgradAddParams {
    file: File
    vo: IFirmwareUpgradItem
}

export type IFirmwareUpgradPageListParams = IPageParams & Partial<{
    startTime
    firmwareName
    endTime
    deviceType: E_FirmwireDeviceType
    typeList: string[]
}>


export interface IFirmwareUpgradPageListItem extends IFirmwareUpgradItem {
    id: number
    createTime: string
    firmwareUrl: string
    firmwareSize: number
    firmwareStatus: number
}

export type IFirmwareUpgradPageListData = IPageData<IFirmwareUpgradPageListItem>

export interface IFirmwareUpgradActionParams {
    id: number
    sensorId: string
}

export interface IFirmwareBatchSensorUpgradeParams {
    /** 固件 ID */
    id: number
    /** 传感器 ID，后端限制最多 200 个 */
    sensorIds: string[]
}

export type T_FirmwareBatchUpgradeResult = 'SUCCESS' | 'SKIPPED' | 'FAILED'

export interface IFirmwareBatchUpgradeResultItem {
    sensorId: string
    result: T_FirmwareBatchUpgradeResult
    message: string
    upgradeRecordId?: number | null
}

export interface IFirmwareBatchSensorUpgradeData {
    totalCount: number
    successCount: number
    skipCount: number
    failCount: number
    items: IFirmwareBatchUpgradeResultItem[]
}


export interface IFirmwareUpgradListUpgradeParams {
    deviceType: E_FirmwireDeviceType
    firmwareType?: string
}

export interface IFirmwareUpgradListUpgradeItem {
    id: number
    createTime: string
    firmwareName: string
    firmwareSize: number
    firmwareUrl: string
    /**
     * 固件版本
     */
    hardwareVersion: string
    /**
     * 软件版本
     */
    softwareVersion: string

    firmwareType: string

    /**
     * 产品类型
     */
    productType: E_FirewireProductType
}
export type IFirmwareUpgradListUpgradeData = IFirmwareUpgradListUpgradeItem[]

export interface IFirmwareUpgradStatusParams {
    id: number
    status: E_UpgradeStatus
}

export type IFirmwareUpgradRecordPageListParams = IPageParams & Partial<{
    beginTime: string
    endTime: string
    firmwareVersion: string
    sensorId: string
    upgradeStatus: E_UpgradeStatus
}>
export interface IFirmwareUpgradRecordPageListItem {
    id: number
    createTime: string
    upgradeTime: string

    firmwareName: string
    firmwareType: string
    firmwareVersion: string

    lastFirmwareName: string
    lastFirmwareType: string
    lastFirmwareVersion: string

    sensorId: string
    upgradeStatus: E_UpgradeStatus
}
export type IFirmwareUpgradRecordPageListData = IPageData<IFirmwareUpgradRecordPageListItem>

export interface IFirmwareUpgradeProgressDataBase {
    errorCode: number
    /**
     * 固件版本
     */
    hardwareVersion: string
    /**
     * 软件版本
     */
    softwareVersion: string

    /**
     * 软件升级进度
     */
    upgradeProgress: number
    /**
     * 软件升级状态
     */
    upgradeStatus: E_FirewareUpgradeStatus
}

export interface IFirmwareUpgradeProgressData extends IFirmwareUpgradItem {
    errorCode: number
    createTime: string
    id: string
    /**
     * 软件升级进度
     */
    upgradeProgress: number
    /**
     * 软件升级状态
     */
    upgradeStatus: E_FirewareUpgradeStatus
    upgradeTime: string
}

export interface IFirmwareGatewayUpgradeActionParams {
    gatewayId: number
    id: number
    // sensorId: string
}

export interface IFirmwareGatewayUpgradeProgressData {
    createTime: string
    upgradeTime
    errorCode: number
    firmwareName
    firmwareSize
    firmwareType
    firmwareUrl
    hardwareVersion
    id
    productType
    softwareVersion
    /**
     * 软件升级进度
     */
    upgradeProgress: number
    upgradeStatus: E_FirewareUpgradeStatus
}
